// extracted by mini-css-extract-plugin
export default {"ImageRow":"style_ImageRow__pcsMZ","Upper":"style_Upper__J0p+Q","OrderLink":"style_OrderLink__2LinX","Message":"style_Message__ZOTEb"};